import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../../../store/store';
import { loadDOMComponent } from '../../../helpers';
import { AppContextProvider } from '../../../Services/AppContext';
import AclContextProvider from '../../Acl/Components/AclContextProvider';
import QuestionnaireStats from '../../Questionnaire/Components/QuestionnaireStats';

loadDOMComponent({
	selector: 'react-questionnaire-stats',
	callback: ({ container, context, props }: any) => {
		const patientId = container.getAttribute('patientId');
		const questionnaireId = container.getAttribute('questionnaireId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<QuestionnaireStats patientId={patientId} />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
